import type { AssessmentResultsDocument, AssessmentResultsListItem } from '@app/types/assessment-results/interfaces'
import type { AssessmentResultsStore } from './interfaces'
import type { ScopeStatus } from '@utils/stores/scoped-entry'

import { useDisciplineStore } from '@stores/discipline'

import { entryData, entryStatus } from '@utils/stores/scoped-entry'

const getActiveId = (): number | null => useDisciplineStore().activeDiscipline?.id ?? null

const getActiveList = (state: AssessmentResultsStore): AssessmentResultsListItem[] => entryData(state.listById, getActiveId()) ?? []

export const getters = {
  getListStatus: (state: AssessmentResultsStore) => (id: number | null): ScopeStatus => entryStatus(state.listById, id),
  getResultStatus: (state: AssessmentResultsStore) => (id: number | null): ScopeStatus => entryStatus(state.resultById, id),
  getResultById: (state: AssessmentResultsStore) => (id: number | null): AssessmentResultsDocument | null => entryData(state.resultById, id),
  isListLoading: (state: AssessmentResultsStore): boolean => entryStatus(state.listById, getActiveId()) === 'loading',
  getList: (state: AssessmentResultsStore): AssessmentResultsListItem[] => getActiveList(state),
  hasList: (state: AssessmentResultsStore): boolean => getActiveList(state).length > 0,
  getUnseenCount: (state: AssessmentResultsStore): number => getActiveList(state).filter(item => !item.is_viewed).length,
}
